import { Column } from './types'

import styles from './useHeaderColumnProps.module.scss'


export const headerProps = {
  [Column.Title]: { alignLeft: true, className: styles.columnTitle },
  [Column.Date]: { alignLeft: true },
  [Column.BalanceAtTheBeginning]: { alignRight: true },
  [Column.Revenue]: { alignRight: true },
  [Column.Collected]: { alignRight: true },
  [Column.BalanceAtTheEnd]: { alignRight: true },
  [Column.EncashmentsCount]: { alignRight: true },
  [Column.Action]: { alignRight: true },
}

export function useHeaderColumnProps() {
  return headerProps
}
